import { useQueryClient } from "react-query";
import { axiosInstance } from "api/axios";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";

/**
 * Konfiguracja wyświetlania statusów per widok — REST API (BE: UiSettingsController),
 * trwałość per użytkownik i aktywny profil. Zastępuje przechowywanie w localStorage
 * (status_display_mode_v1 / status_icons_v1 / status_chip_overrides_v1). LocalStorage
 * pozostaje warstwą podręczną hydratowaną z BE (synchroniczne odczyty w renderCell).
 */

export interface IStatusIcon {
  StatusId: number;
  IconName: string;
}

export interface IStatusOverride {
  StatusId: number;
  Name: string;
  Color: number;
}

export interface IStatusDisplayConfig {
  View: string;
  Mode: "chip" | "icon";
  Icons: IStatusIcon[];
  Overrides: IStatusOverride[];
}

const getStatusDisplayApi = async (view: string): Promise<IStatusDisplayConfig> =>
  (await axiosInstance.get<IStatusDisplayConfig>(`/ui/status-display/${view}`)).data;

const saveStatusDisplayApi = async (
  config: IStatusDisplayConfig,
): Promise<IStatusDisplayConfig> =>
  (await axiosInstance.put<IStatusDisplayConfig>(`/ui/status-display/${config.View}`, config))
    .data;

const QUERY_KEY = "statusDisplay";

const uiSettingsService = {
  useGetStatusDisplay: (view: string) =>
    useCustomQuery<IStatusDisplayConfig>(
      [QUERY_KEY, view],
      () => getStatusDisplayApi(view),
      { retry: false, enabled: !!view },
    ),

  useSaveStatusDisplay: () => {
    const queryClient = useQueryClient();
    return useCustomMutation<IStatusDisplayConfig, IStatusDisplayConfig>(saveStatusDisplayApi, {
      onSuccess: (data) => {
        queryClient.setQueryData([QUERY_KEY, data.View], data);
      },
    });
  },
};

export default uiSettingsService;
